import axiosInstance from "../lib/axios.instance";
import { encodePathSegment } from "./path.utils";
import {
  RequestCategory,
  CreateRequestCategoryPayload,
  UpdateRequestCategoryPayload,
  CreateRequestCategoryResponse,
  UpdateRequestCategoryResponse,
  DeleteRequestCategoryResponse,
  Request,
  CreateRequestPayload,
  UpdateRequestPayload,
  CreateRequestResponse,
  UpdateRequestResponse,
  DeleteRequestResponse,
  GetHeadingsPayload,
  GetHeadingsResponse,
} from "../types/research.types";

export const requestCategoryService = {
  // Get all request categories
  getRequestCategories: async (): Promise<RequestCategory[]> => {
    const response = await axiosInstance.get<RequestCategory[]>("/ai/chat/cat");
    return response.data;
  },

  // Get all requests by type
  getRequests: async (type: string): Promise<Request[]> => {
    const response = await axiosInstance.get<Request[]>(
      `/ai/chat/requests/${encodePathSegment(type)}`
    );
    return response.data;
  },

  // Create a new request category
  createRequestCategory: async (
    payload: CreateRequestCategoryPayload
  ): Promise<CreateRequestCategoryResponse> => {
    const response = await axiosInstance.post<CreateRequestCategoryResponse>(
      "/ai/chat/cat",
      payload
    );
    return response.data;
  },

  // Update a request category
  updateRequestCategory: async (
    payload: UpdateRequestCategoryPayload
  ): Promise<UpdateRequestCategoryResponse> => {
    const { id, ...data } = payload;
    const response = await axiosInstance.put<UpdateRequestCategoryResponse>(
      `/ai/chat/cat/${encodePathSegment(id)}`,
      data
    );
    return response.data;
  },

  // Delete a request category
  deleteRequestCategory: async (categoryId: string): Promise<DeleteRequestCategoryResponse> => {
    const response = await axiosInstance.delete<DeleteRequestCategoryResponse>(
      `/ai/chat/cat/${encodePathSegment(categoryId)}`
    );
    return response.data;
  },

  // Create a new request
  createRequest: async (payload: CreateRequestPayload): Promise<CreateRequestResponse> => {
    const response = await axiosInstance.post<CreateRequestResponse>("/ai/chat/request", payload);
    return response.data;
  },

  // Update a request
  updateRequest: async (payload: UpdateRequestPayload): Promise<UpdateRequestResponse> => {
    const { id, ...data } = payload;
    const response = await axiosInstance.put<UpdateRequestResponse>(
      `/ai/chat/request/${encodePathSegment(id)}`,
      data
    );
    return response.data;
  },

  // Delete a request
  deleteRequest: async (requestId: string): Promise<DeleteRequestResponse> => {
    const response = await axiosInstance.delete<DeleteRequestResponse>(
      `/ai/chat/request/${encodePathSegment(requestId)}`
    );
    return response.data;
  },

  // Get headings based on related questions
  getHeadings: async (payload: GetHeadingsPayload): Promise<GetHeadingsResponse> => {
    const response = await axiosInstance.post<GetHeadingsResponse>("/ai/chat/headings", payload);
    return response.data;
  },
};
